import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "fixed inset-0 z-50 flex items-center justify-center" };
const _hoisted_2 = { class: "relative bg-white rounded-2xl shadow-xl w-full max-w-md mx-4 flex flex-col max-h-[70vh]" };
const _hoisted_3 = { class: "flex items-center justify-between px-5 py-4 border-b border-gray-100" };
const _hoisted_4 = { class: "text-base font-semibold text-gray-900" };
const _hoisted_5 = { class: "px-4 py-3 border-b border-gray-100" };
const _hoisted_6 = ["placeholder"];
const _hoisted_7 = { class: "flex-1 overflow-y-auto" };
const _hoisted_8 = {
    key: 0,
    class: "flex justify-center py-8"
};
const _hoisted_9 = {
    key: 1,
    class: "py-8 text-sm text-center text-gray-400"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = { class: "text-sm font-medium text-gray-900" };
const _hoisted_12 = {
    key: 0,
    class: "text-xs text-gray-400"
};
import { ref, computed } from "vue";
import { IconX } from "@tabler/icons-vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ServiceSelectModal',
    props: {
        services: {},
        isLoading: { type: Boolean }
    },
    emits: ["select", "cancel"],
    setup(__props) {
        const props = __props;
        const search = ref("");
        const filteredServices = computed(() => {
            const q = search.value.toLowerCase().trim();
            if (!q)
                return props.services;
            return props.services.filter((s) => s.name.toLowerCase().includes(q) ||
                s.provider_name?.toLowerCase().includes(q));
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", {
                        class: "absolute inset-0 bg-black/40 backdrop-blur-sm",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('cancel')))
                    }),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("conversation.auto.select_a_service")), 1),
                            _createElementVNode("button", {
                                onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('cancel'))),
                                class: "p-1 text-gray-400 rounded-lg hover:bg-gray-100"
                            }, [
                                _createVNode(_unref(IconX), { class: "w-5 h-5" })
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((search).value = $event)),
                                type: "text",
                                placeholder: _ctx.$t('conversation.auto.search_services'),
                                class: "w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-eorange-400"
                            }, null, 8, _hoisted_6), [
                                [_vModelText, search.value]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            (__props.isLoading)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[3] || (_cache[3] = [
                                        _createElementVNode("div", { class: "w-5 h-5 border-2 rounded-full border-eorange-400 border-t-transparent animate-spin" }, null, -1)
                                    ]))]))
                                : (!filteredServices.value.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t("conversation.auto.no_services_found")), 1))
                                    : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredServices.value, (svc) => {
                                return (_openBlock(), _createElementBlock("button", {
                                    key: svc.id,
                                    onClick: ($event) => (_ctx.$emit('select', svc)),
                                    class: "w-full px-4 py-3 text-left transition-colors border-b border-gray-100 hover:bg-gray-50 last:border-0"
                                }, [
                                    _createElementVNode("p", _hoisted_11, _toDisplayString(svc.name), 1),
                                    (svc.provider_name)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(svc.provider_name), 1))
                                        : _createCommentVNode("", true)
                                ], 8, _hoisted_10));
                            }), 128))
                        ])
                    ])
                ])
            ]));
        };
    }
});
